import { ControlPopUpModule } from 'src/app/widgets/control-pop-up/control-pop-up.module';
import { DirectivesModule } from 'src/app/directives/directives/directives.module';
import { DxDropDownButtonModule, DxPopupModule, DxButtonModule, DxSelectBoxModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JumpToComponent } from './jump-to.component';

@NgModule({
  declarations: [JumpToComponent],
	exports: [JumpToComponent],
  imports: [
    CommonModule,
		DirectivesModule,

		ControlPopUpModule,

		DxDropDownButtonModule,
		DxPopupModule,
		DxButtonModule,
		DxSelectBoxModule,
  ]
})
export class JumpToModule { }
